import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Header from './components/Header';
import NotFound from './components/404';
import routes from './routes';

import {
	fetchContentAction,
	fetchInitialContent
} from './services/content/actions';

import { fetchComponentData } from './services/contentEvents/actions';
import Recptcha from './components/ReCaptcha';

class App extends React.Component {

	fetchData = (page, primary = false, key = null) => {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'wwww.guinnessopengate.com';
		const url = `https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/${
			key ? key : page.toLowerCase()
		}.json?v=${Math.random()}`;
		this.props.fetchContent(url, page, primary);
	};

	componentDidMount() {
		// For development environment - if initialState data does not exist inline in html page
		// then load it in from local file
		if (!initialState || !initialState.length) {
			this.props.fetchInitialContent('/data/data.json');
		}

		/*if(sessionStorage.getItem('initialLoad') == 1){
      //nothing
    } else{
      sessionStorage.setItem('initialLoad', 1);
    }*/
	}

	render() {
		if (!initialState || !initialState.length) {
			console.log('No initialState');
			return <div />;
		}

		return (
			<Router basename="/">
				<div>
					<Header
						data={this.props.navigationData}
						fetchData={this.fetchData}
						showLogo={this.props.showLogo}
					/>
					<Switch>
						{routes.map((route) => {
							const componentData = {};

							route.additionalKeys
								? route.additionalKeys.forEach(
									(key) => (componentData[key.title] = this.props[key.name])
								  )
								: null;
							const dataProps = {
								data: this.props[`${route.key}Data`],
								componentData,
								fetchData: this.fetchData,
								apiPath: route.apiPath,
								className: route.className
							};

							return (
								<Route
									exact={route.path === '/'}
									path={route.path}
									key={route.key}
									render={(props) => route.component({
										...dataProps,
										routeProps: props
									})}
								/>
							);
						})}
						<Route component={NotFound} />
					</Switch>
					<Recptcha />
				</div>
			</Router>
		);
	}
}

const mapStateToProps = (state) => ({
	homePageData: state.content.homePage,
	visitUsPageData: state.content.visitUsPage,
	theBeersPageData: state.content.theBeersPage,
	theBeersFilterData: state.content.beersFilter,
	theBreweryPageData: state.content.theBreweryPage,
	beerPageData: state.content.beerPage,
	signUpFormData: state.content.signUpForm,
	privateBookingFormData: state.content.privateBookingForm,
	faqsPageData: state.content.faqsPage,
	navigationData: state.content.navigation,
	showLogo: state.logo.headerLogoShow
});

export default connect(mapStateToProps, {
	fetchContent: fetchContentAction,
	fetchInitialContent
})(App);



// WEBPACK FOOTER //
// ./src/App.js